'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:UserSearch
 * @description
 * Controller of the cimerFrontEndApp
 */

angular.module('cimerFrontEndApp')
    .controller('UserSearchCtrl', ['$scope', '$http', '$location', '$anchorScroll', 'ApiUrl', 'Session', 'ReportService', '$timeout', function ($scope, $http, $location, $anchorScroll, ApiUrl, Session, ReportService, $timeout) {

        var sessionObject = Session.getSessionObject();
        if (!sessionObject.isAuthenticated || !(sessionObject.isAdmin || sessionObject.isProjectAdmin)) {
            $location.url('/');
            return;
        }

        $scope.input = {
            Name: '',
            Email: null
        };

        $scope.searching = true;
        $scope.saving = false;
        $scope.isAdmin = false;
        if (sessionObject.isAdmin) {
            $scope.isAdmin = true;
        }

        var _apiUrl = ApiUrl.url('/User/');

        $scope.roles = [
            { Name: "EventCreator", DisplayName: "Event Creator", Selected: false },
            { Name: "Administrator", DisplayName: "Administrator", Selected: false },
            { Name: "CurriculaAdmin", DisplayName: "Curricula Admin", Selected: false }
        ];

        var clearPasswordFields = function () {
            $scope.newPassword = '';
            $scope.confirmNewPassword = '';
        };

        $scope.search = function () {
            $scope.searching = true;
            $http.get(_apiUrl + 'DetailList', { params: $scope.input })
                .then(function (response) {
                    $scope.userResults = response.data;
                });
        };

        $scope.editUser = function (userId) {
            $scope.searching = false;
            $scope.passwordMessage = '';
            $scope.selectedUser = null;
            
            clearPasswordFields();
            $http.get(_apiUrl + 'UserDetails', { params: { userId: userId } })
                .then(function (response) {
                    $scope.selectedUser = response.data;                  
                    var flattenedSurveys = [];
                    for (var i = 0; i < response.data.GrantSurveys.length; i++) {
                        var grant = response.data.GrantSurveys[i];
                        for (var j = 0; j < grant.Surveys.length; j++) {
                            var survey = grant.Surveys[j];
                            survey.Grant = grant.Name;
                            survey.ProjectName = grant.ProjectName;
                            survey.SectionName = grant.SectionName;
                            survey.DateAssigned = new Date(grant.DateAssigned);
                            flattenedSurveys.push(survey);
                        }
                    }

                    $scope.selectedUser.flattenedSurveys = flattenedSurveys;

                    $scope.setRolesForEdit();

                    $anchorScroll("top");
                });
        };

        $scope.selectedUserRoles = function () {           
            const roles = $scope.selectedUser.Roles.map(function (role) {
                let newRole = '';
                switch (role) {
                    case 'Alternate':
                        newRole = createRoleList($scope.selectedUser.ProjectAlternateNames, 'Event Admin Alternate');                
                        break;
                    case 'ProjectAdmin':
                        newRole = createRoleList($scope.selectedUser.ProjectAdminNames, 'Admin');
                        break;
                    case 'Director':
                        newRole = createRoleList($scope.selectedUser.ProjectDirectorNames, 'Event Admin');
                        break;
                    case 'SurveyTaker':
                        newRole = 'Survey User';
                        break;
                    case 'CurriculaAdmin':
                        newRole = 'Curricula Admin';
                        break;
                    case 'EventCreator':
                        newRole = 'Event Creator';
                        break;
                    default:
                        newRole = role; //Administrator/catch all
                        break;
                }
                return newRole;
            });

            return roles.join(', ').replace(/,(\s+)?$/, '');   
        };

        function createRoleList(projectList, text) {
            var list = '';

            if (!projectList) {
                return;
            }


            for (let x = 0; x < projectList.length; x++) {
                list += `${projectList[x]} ${text}, `;
            }

            return list.replace(/,(\s+)?$/, '');   
        }
        

        $scope.submitPasswordChange = function () {
            var data = {
                currentPassword: 'foo',
                newPassword: $scope.newPassword,
                confirmNewPassword: $scope.confirmNewPassword
            };
            $http.post(_apiUrl + 'UpdatePassword/' + $scope.selectedUser.ID, data)
                .then(function (response) {
                    $scope.passwordMessage = '';
                    if (response.data.Changed) {
                        clearPasswordFields();
                        $scope.passwordMessage = "Password successfully changed.";
                    } else {
                        if (response.data.Errors.length > 0) {
                            for (var i = 0; i < response.data.Errors.length; i++) {
                                $scope.passwordMessage += response.data.Errors[i];
                                if (i + 1 < response.data.Errors.length) {
                                    $scope.passwordMessage += ", ";
                                }
                            }
                        } else {
                            $scope.passwordMessage = "There was an error updating the password.";
                        }
                    }
                });
        };

        $scope.downloadSurveyReport = function (surveyId) {
            ReportService.downloadDataCsv(surveyId);
        };

        // This sets the roles for the user when initially loaded
        // This resets the roles if the user clicks cancel on the form
        $scope.setRolesForEdit = function () {
            // clear all the selected roles
            for (var i = 0; i < $scope.roles.length; i++) {
                $scope.roles[i].Selected = false;
            }

            // set the roles
            $scope.selectedUser.Roles.map(function (role) {
                switch (role) {
                    case 'CurriculaAdmin':
                    case 'EventCreator':
                    case 'Administrator':
                        setHasRole(role);
                        break;
                    default:
                        break;
                }
            });
        };

        $scope.saveRoles = function () {
            $scope.saving = true;
            var data = {
                CurrentUserName: $scope.selectedUser.UserName,
                Roles: $scope.roles
            };
            $http.post(_apiUrl + 'SaveRoles', data).then(function (response) {
                if (response.data) {
                    $scope.selectedUser.Roles = response.data;
                    $scope.successMessage();
                }
                $scope.saving = false;
            }, function (err) {
                $location.path('error');
            });
        };

        $scope.successMessage = function () {
            $scope.uploadMessage = 'Roles(s) successfully updated';
            $timeout(function () {
                $scope.uploadMessage = '';
            }, 5000);
        }

        var setHasRole = function (roleName) {
            for (var i = 0; i < $scope.roles.length; i++) {
                if ($scope.roles[i].Name == roleName) {
                    $scope.roles[i].Selected = true;
                }
            }
        };
    }]);